/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Occupation_StandingInputs */

const en_us2_occupation_standing = /** @type {(inputs: Occupation_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On my feet`)
};

const pt_br2_occupation_standing = /** @type {(inputs: Occupation_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em pé`)
};

const es_419_occupation_standing = /** @type {(inputs: Occupation_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De pie`)
};

const pt_pt2_occupation_standing = /** @type {(inputs: Occupation_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De pé`)
};

const fr_fr2_occupation_standing = /** @type {(inputs: Occupation_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debout`)
};

const de_de2_occupation_standing = /** @type {(inputs: Occupation_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Stehen`)
};

const it_it2_occupation_standing = /** @type {(inputs: Occupation_StandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In piedi`)
};

/**
* | output |
* | --- |
* | "On my feet" |
*
* @param {Occupation_StandingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const occupation_standing = /** @type {((inputs?: Occupation_StandingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Occupation_StandingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_occupation_standing(inputs)
	if (locale === "es-419") return es_419_occupation_standing(inputs)
	if (locale === "pt-PT") return pt_pt2_occupation_standing(inputs)
	if (locale === "fr-FR") return fr_fr2_occupation_standing(inputs)
	if (locale === "de-DE") return de_de2_occupation_standing(inputs)
	if (locale === "it-IT") return it_it2_occupation_standing(inputs)
	return en_us2_occupation_standing(inputs)
});
export { occupation_standing as "occupation.standing" }